// ErrorBoundaryFallback.js
import React from "react";
import { useErrorBoundary } from "react-error-boundary";

const ErrorBoundaryFallback = ({ error }) => {
    console.error( error );
    const { resetBoundary } = useErrorBoundary();
    
    return (
        <div style={{ padding: "20px", textAlign: "center" }}>
            <h3>Something has gone wrong...</h3>
            <p>Your browser may be outdated and doesn’t support the features required to run this application. Please update your browser to the latest version.</p>
            <p>If you don't belive your browser is outdated, please copy the below error message and sent it to hello@optomconnect.com.au, along with a detailed description of what page you were on and what you were trying to do when the error occurred.</p>
            <div class="alert alert-danger" role="alert">
                {error?.message || "An unexpected error occurred."}
            </div>
            <button onClick={resetBoundary}>Try Again</button>
        </div>
    )
};

export default ErrorBoundaryFallback;
